module.exports = __webpack_public_path__ + "img/download_fangzhen.5f816eb3.png";